import { Formik, Form } from 'formik'
import { GeneralSetting } from '@apis'
import { SettingSchema } from '@validations'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import SettingCard from '../settingCard'
import { StyleFormGrid } from './style'
import Fields from '@components/fields'
import Button from '@components/button'
import Column from '@components/column'

const Charge = () => {
  const { data: platformCharge } = useSelector(
    (state: any) => state.platformCharge,
  )
  const initial = {
    value: {
      doctorRate: 0,
      clinicRate: 0,
      pharmacyRate: 0,
    },
    key: 'platform-charge',
    title: 'Platform Charge',
  }
  const [initialValues, setInitialValues] = useState(initial)
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setLoading(true)
    if (platformCharge?.id) {
      await GeneralSetting.update({
        id: platformCharge?.id,
        data: {
          ...values,
          value: JSON.stringify(values?.value),
        },
        state: 'platformCharge',
      }).catch(() => {})
    } else {
      await GeneralSetting.create({
        data: {
          ...values,
          value: JSON.stringify(values?.value),
        },
        state: 'platformCharge',
      }).catch(() => {})
    }
    setLoading(false)
  }
  const fetchData = async () => {
    await GeneralSetting.getByKey({
      id: 'platform-charge',
      state: 'platformCharge',
    })

      .catch(() => {})
  }
  useEffect(() => {
    if (platformCharge?.id) {
      setInitialValues({
        ...initialValues,
        value: JSON.parse(platformCharge?.value),
      })
    } else {
      setInitialValues(initial)
    }
  }, [platformCharge?.id])

  useEffect(() => {
    if (!platformCharge?.id) {
      fetchData()
    }
  }, [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      enableReinitialize
      validationSchema={SettingSchema.platformChargeValidationSchema}
    >
      {({ handleSubmit }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <SettingCard title="Platform Charge">
              <StyleFormGrid>
                <Fields.Input
                  type="number"
                  name="value[doctorRate]"
                  placeholder="Enter Doctor Rate"
                  label="Doctor Rate (In Percent)"
                />
                <Fields.Input
                  type="number"
                  name="value[clinicRate]"
                  placeholder="Enter Clinic Rate"
                  label="Clinic Rate (In Percent)"
                />
                <Fields.Input
                  type="number"
                  name="value[pharmacyRate]"
                  placeholder="Enter Pharmacy Rate"
                  label="Pharmacy Rate (In Percent)"
                />
              </StyleFormGrid>
            </SettingCard>
            <Column alignItems="flex-end" styleColumn="margin-top:30px;">
              <Button
                type="submit"
                title="Save"
                height={40}
                loading={loading}
              />
            </Column>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Charge
